import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const BreakTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const updateTactic = (field, newValue) => {
      updatePlugins('setup', { [field]: newValue }, 'BREAK', tradePlanId, null);
    };
    if (!tradePlan?.setupDetails['BREAK']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Price to Break
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    bodySize={3}
                    initialValue={tradePlan.setupDetails['BREAK'].priceToBreak}
                    updateValue={(newValue) =>
                      updateTactic('priceToBreak', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

BreakTacticPanel.tabsRole = 'TabPanel';
